export default [
  {
    path: '/project/:proj_id',
    component: () => import('@/layouts/ProjectLayout.vue'),
    meta:{
      authRequired: true
    },
    children: [
      {
        path: 'field/info/:type',
        name: 'field-info-type',
        meta: {
          activeCode: 'field-info'
        },
        component: () => import('@/views/_BS/FieldInfo.vue')
      },


// ========== 사업장(직접수행)
      {
        path: 'field/workplace',
        name: 'field-workplace-list',
        meta: {
          activeCode: 'field-workplace'
        },
        component: () => import('@/views/_BS/FieldWorkplaceList.vue')
      },
      {
        path: 'field/workplace/write',
        name: 'field-workplace-create',
        meta: {
          activeCode: 'field-workplace'
        },
        component: () => import('@/views/_BS/FieldWorkplaceWrite.vue')
      },
      {
        path: 'field/workplace/write/:postId',
        name: 'field-workplace-update',
        meta: {
          activeCode: 'field-workplace'
        },
        component: () => import('@/views/_BS/FieldWorkplaceWrite.vue')
      },
      {
        path: 'field/workplace/info',
        name: 'field-workplace-info',
        meta: {
          activeCode: 'field-workplace'
        },
        component: () => import('@/views/_BS/FieldWorkplaceInfo.vue')
      },

// ========== 사업장(용역위탁)
      {
        path: 'field/workplace2',
        name: 'field-workplace2-list',
        meta: {
          activeCode: 'field-workplace2'
        },
        component: () => import('@/views/_BS/FieldWorkplace2List.vue')
      },
      {
        path: 'field/workplace2/write',
        name: 'field-workplace2-create',
        meta: {
          activeCode: 'field-workplace2'
        },
        component: () => import('@/views/_BS/FieldWorkplace2Write.vue')
      },
      {
        path: 'field/workplace2/write/:postId',
        name: 'field-workplace2-update',
        meta: {
          activeCode: 'field-workplace2'
        },
        component: () => import('@/views/_BS/FieldWorkplace2Write.vue')
      },
      {
        path: 'field/workplace2/info',
        name: 'field-workplace2-info',
        meta: {
          activeCode: 'field-workplace2'
        },
        component: () => import('@/views/_BS/FieldWorkplace2Info.vue')
      },


// ========== facility
      {
        path: 'field/facility',
        name: 'field-facility-list',
        meta: {
          activeCode: 'field-facility'
        },
        component: () => import('@/views/_BS/FieldFacilityList.vue')
      },
      {
        path: 'field/facility/write',
        name: 'field-facility-create',
        meta: {
          activeCode: 'field-facility'
        },
        component: () => import('@/views/_BS/FieldFacilityWrite.vue')
      },
      {
        path: 'field/facility/write/:postId',
        name: 'field-facility-update',
        meta: {
          activeCode: 'field-facility'
        },
        component: () => import('@/views/_BS/FieldFacilityWrite.vue')
      },
      {
        path: 'field/facility/info',
        name: 'field-facility-info',
        meta: {
          activeCode: 'field-facility'
        },
        component: () => import('@/views/_BS/FieldFacilityInfo.vue')
      },


// ========== field
      {
        path: 'field/field',
        name: 'field-field-list',
        meta: {
          activeCode: 'field-field'
        },
        component: () => import('@/views/_BS/FieldFieldList.vue')
      },
      {
        path: 'field/field/write',
        name: 'field-field-create',
        meta: {
          activeCode: 'field-field'
        },
        component: () => import('@/views/_BS/FieldFieldWrite.vue')
      },
      {
        path: 'field/field/write/:postId',
        name: 'field-field-update',
        meta: {
          activeCode: 'field-field'
        },
        component: () => import('@/views/_BS/FieldFieldWrite.vue')
      },
      {
        path: 'field/field/info',
        name: 'field-field-info',
        meta: {
          activeCode: 'field-field'
        },
        component: () => import('@/views/_BS/FieldFieldInfo.vue')
      },


// ==========
      {
        path: 'company/info',
        name: 'company-info',
        meta: {
          activeCode: 'company-info'
        },
        component: () => import('@/views/_BS/CompanyInfo.vue')
      },
    ]
  }
]
